import React from "react";
import { FaPlus } from "react-icons/fa";
import * as RR from "react-redux";
import styled from "styled-components";
import { IFullOrganization } from "../../../../../parsers/resolve";
import { PreferredLocale } from "../../../../../utils/locales";
import * as actions from "../../actions";

const AddOrgDiv = styled.div`
  align-items: center;
  color: #4e799f;
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  gap: 1rem;
  height: 35px;
`;

interface IAddOrg {
  owner: string;
}

export const createNewOrganization = (owner: string): IFullOrganization => ({
  admins: [],
  aliases: { elems: [], nextId: 0 },
  defaultLocale: PreferredLocale.en,
  deleted: false,
  displayName: "New Organisation",
  owner,
  releaseLine: "master",
  scormSettings: {
    hideNavBar: false,
    lms: "GenericLMS",
    primaryKey: "ScormLearnerId",
    scormVersion: "1_2",
  },
  storeLearnerLog: false,
  style: null,
  useSimpleHtmlClient: true,
});

const AddOrg: React.FC<IAddOrg> = ({ owner }) => {
  const dispatch = RR.useDispatch();

  const handleClick = () => {
    dispatch(actions.createNewOrganization(createNewOrganization(owner)));
  };

  return (
    <AddOrgDiv onClick={handleClick}>
      <FaPlus />
      Add new organisation
    </AddOrgDiv>
  );
};

export default AddOrg;
